import React from "react";
import "../style/CustomPopup.css";

const CustomPopup = ({
  open,
  onClose,
  title,
  message,
  icon,
  image,
  children,    // <- must accept children
  showClose = true, // optional prop to hide the Close button
}) => {
  // quick debug: uncomment to verify open value in console
  // console.log("CustomPopup open:", open);

  if (!open) return null;

  return (
    <div
      className="popup-overlay"
      onClick={onClose}               // clicking overlay closes
      role="dialog"
      aria-modal="true"
    >
      <div
        className="popup-container"
        onClick={(e) => e.stopPropagation()} // prevent overlay click when interacting inside
      >
        {/* optional image / icon / title */}
        {image && <img src={image} alt="popup" className="popup-image" />}
        {icon && <div className="popup-icon">{icon}</div>}
        {title && <h4 className="popup-title">{title}</h4>}
        {message && <p className="popup-message">{message}</p>}

        {/* ===== your children shown here ===== */}
        <div className="popup-children">
          {children}
        </div>

       
      </div>
    </div>
  );
};

export default CustomPopup;
